import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Dropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: this.props.options,
            disabled: this.props.disabled,
            error: this.props.error,
            placeholder: this.props.placeholder,
            value: this.props.value
        };
    };

    componentWillMount() {};

    componentDidMount(){
        this.setState({
            options: this.props.options,
            disabled: this.props.disabled,
            error: this.props.error,
            placeholder: this.props.placeholder,
            value: this.props.value
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            options: nextProps.options,
            disabled: nextProps.disabled,
            error: nextProps.error,
            placeholder: nextProps.placeholder,
            value: nextProps.value
        });
    }

    functions = {
        select: (value) => {
            this.props.onChange(value, false);
        }
    };

    renders = {
        value: (value) => {
            try {
                if(this.state.disabled && value === "-1"){
                    return this.state.placeholder;
                }else{
                    return JSON.parse(value).title;
                }
            }catch (e) {}
        }
    };

    render() {
        return (
            <div className={
                cx(Styles.dropdown,
                    {
                        [Styles.dropdownError]: this.state.error,
                        [Styles.dropdownErrorYieldlock]: salesChannelRegister.get("name") === "yieldlock" && this.state.error,
                        [Styles.dropdownDisabled]: this.state.disabled,
                    })
            }>
                <select
                    value={this.state.value}
                    disabled={this.state.disabled}
                    className={Styles.dropdownSelection}
                    onChange={(event) => this.functions.select(event.target.value)}
                >
                    <option value="-1">{this.state.placeholder}</option>
                    {
                        this.state.options.map((item, index) => {
                            return (
                                <option key={index} className={Styles.dropdownSelectionOption} value={JSON.stringify(item)}>{item.title}</option>
                            )
                        })
                    }
                </select>
                {
                    this.state.value === "-1" && !this.state.disabled && !this.state.error &&
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>{this.state.placeholder}</div>
                }
                {
                    this.state.value !== "-1" && !this.state.disabled && !this.state.error &&
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>{this.renders.value(this.state.value)}</div>
                }
                {
                    this.state.value === "-1" && !this.state.disabled && this.state.error &&
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}} className={Styles.dropdownText}>{this.state.placeholder}</div>
                }
                {
                    this.state.value !== "-1" && !this.state.disabled && this.state.error &&
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}} className={Styles.dropdownText}>{this.state.placeholder}</div>
                }
                {
                    this.state.disabled &&
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={Styles.dropdownText}>{this.renders.value(this.state.value)}</div>
                }


                {
                    salesChannelRegister.get('name') !== "yieldlock" && !this.state.error && !this.state.disabled &&
                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                }
                {
                    salesChannelRegister.get('name') !== "yieldlock" && this.state.error && !this.state.disabled &&
                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-error.svg")}/>
                }
                {
                    salesChannelRegister.get('name') !== "yieldlock" && this.state.disabled &&
                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>
                }

                {
                    salesChannelRegister.get('name') === "yieldlock" && !this.state.error && !this.state.disabled &&
                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                }
                {
                    salesChannelRegister.get('name') === "yieldlock" && this.state.error && !this.state.disabled &&
                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-error-yl.svg")}/>
                }
                {
                    salesChannelRegister.get('name') === "yieldlock" && this.state.disabled &&
                    <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>
                }

                {/*
                {
                    !this.state.error && !this.state.disabled &&
                    <img style={salesChannelRegister.get('name')==='yieldlock'?{fill: '#00273A'}:{}} className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                }
                {
                    this.state.error && !this.state.disabled &&
                    <img style={salesChannelRegister.get('name')==='yieldlock'?{fill: '#E65032'}:{}} className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-error.svg")}/>
                }
                {
                    this.state.disabled && false &&
                    <img style={salesChannelRegister.get('name')==='yieldlock'?{fill: '#CCD4D7'}:{}} className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>
                }
                */}
            </div>
        );
    }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/dropdown/component.js